"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const angular2_moment_1 = require("angular2-moment");
const platform_browser_1 = require("@angular/platform-browser");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const bidder_service_1 = require("./bidder.service");
const bid_data_service_1 = require("./bid-data.service");
const user_service_1 = require("./user.service");
const dashboard_report_service_1 = require("./dashboard-report.service");
const permission_service_1 = require("./permission.service");
const bid_data_filter_service_1 = require("./bid-data-filter.service");
const events_1 = require("./events");
const branding_service_1 = require("./branding.service");
const loading_service_1 = require("./loading.service");
let PortalComponent = class PortalComponent {
    sortSign() {
        if (this.sortMod) {
            return '+';
        }
        else {
            return '-';
        }
    }
    constructor(_router, _bidder, _bidData, _datePipe, _bidDataFilter, _title, _loading, _token, _user, _permission, _report, _branding) {
        this._router = _router;
        this._bidder = _bidder;
        this._bidData = _bidData;
        this._datePipe = _datePipe;
        this._bidDataFilter = _bidDataFilter;
        this._title = _title;
        this._loading = _loading;
        this._token = _token;
        this._user = _user;
        this._permission = _permission;
        this._report = _report;
        this._branding = _branding;
        this.sortList = 'updatedAt';
        this.sortMod = false;
        this.searchTerm = '';
        this.adInspectorAddress = '';
        this.transferProtocol = 'http://';
        this._title.setTitle(this._branding.getProductSuiteTitle());
        this.permission = _permission.get();
    }
    ngOnInit() {
        this.bidders = this._bidder.get();
        this.reports = this._user.getReports();
        this.loadEvents();
    }
    loadEvents() {
        this.events = new events_1.PortalEvents({
            user: this._user.get().id
        });
    }
    openBidder(bidderId) {
        this._loading.start("Loading Bidder...");
        this._router.navigate(['controlcenter/edit', bidderId]);
    }
    copyBidder(bidderId) {
        this._loading.start("Loading Bidder...");
        this._bidder.bidderId = bidderId;
        this._router.navigate(['controlcenter/copy']);
    }
    dashboardHelp() {
        this.events.send({
            subFeature: events_1.EventSubFeature.help,
            context: 'dashboard',
            subject: 'dashboard',
            action: events_1.EventAction.clicked
        });
    }
    getRevenueTitle() {
        return `Revenue${this.showBillingDisclaimer() ? ' *' : ''}`;
    }
    getAdRendersTitle() {
        return `Ad Renders${this.showBillingDisclaimer() ? ' *' : ''}`;
    }
    getECPMTitle() {
        return `eCPM${this.showBillingDisclaimer() ? ' *' : ''}`;
    }
    showBillingDisclaimer() {
        return this._branding.showBillingDisclaimer();
    }
    controlcenterHelp() {
        this.events.send({
            subFeature: events_1.EventSubFeature.help,
            context: 'control-center',
            subject: 'control-center',
            action: events_1.EventAction.clicked
        });
    }
    openAdInspectorAddress(url) {
        url = url.replace(/http:\/\/|https:\/\//i, "");
        window.open(this.transferProtocol + url + '?biddr_adinspector');
        this.events.send({
            subFeature: events_1.EventSubFeature.adInspector,
            subject: url,
            action: events_1.EventAction.clicked
        });
    }
    adInspectorKeypress(event) {
        if (event.keyCode == 13) {
            this.openAdInspectorAddress(this.adInspectorAddress);
        }
    }
    sort(sortBy) {
        if (this.sortList == sortBy) {
            this.sortMod = !this.sortMod;
        }
        else {
            this.sortList = sortBy;
            this.sortMod = true;
        }
    }
    displayDateRange() {
        let dateRange = this._bidDataFilter.getDateRange();
        return dateRange.start + " - " + dateRange.end;
    }
    openReport(report) {
        this._report.openReport(report);
    }
    noNavigate(event) {
        event.stopPropagation();
    }
    support(type) {
        this._user.zendeskSupport([type])
            .then(res => { this._token.externalRedirect((res.redirectLinks && res.redirectLinks[type]) || res.redirect); })
            .catch(err => {
            console.log(`For some reason we are unable to get support redirect link: ${err.message}`);
            // If we are unable to get the tokenized url, just go to default page as fallback; 
            this._token.externalRedirect('https://biddr360.zendesk.com/hc/en-us');
        });
    }
};
exports.PortalComponent = PortalComponent;
exports.PortalComponent = PortalComponent = __decorate([
    (0, core_1.Component)({
        selector: 'my-portal',
        templateUrl: 'app/portal.component.html',
        styleUrls: ['styles/portal.component.css']
    }),
    __metadata("design:paramtypes", [router_1.Router,
        bidder_service_1.BidderService,
        bid_data_service_1.BidDataService,
        angular2_moment_1.DateFormatPipe,
        bid_data_filter_service_1.BidDataFilterService,
        platform_browser_1.Title,
        loading_service_1.LoadingService,
        token_service_1.TokenService,
        user_service_1.UserService,
        permission_service_1.PermissionService,
        dashboard_report_service_1.DashboardReportService,
        branding_service_1.BrandingService])
], PortalComponent);
//# sourceMappingURL=portal.component.js.map